export const anuncioMockup = (parameter) => {
    const anuncioId = parameter.split('-').pop();

    return anuncioId;
}
